import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6087af27"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "child" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Match Face In Images", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Target Image: ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "file",
  name: "needle",
  accept: "image/png, image/jpeg"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Source Images: ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "file",
  name: "haystack",
  accept: "image/png, image/jpeg",
  multiple: ""
}, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode()
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", { type: "submit" }, null, -1))
const _hoisted_10 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.findInImages && _ctx.findInImages(...args)), ["prevent"]))
    }, _hoisted_10, 32),
    _createElementVNode("h4", null, "result: " + _toDisplayString(_ctx.result), 1),
    _createElementVNode("h5", _hoisted_11, _toDisplayString(_ctx.error), 1)
  ]))
}